import React from 'react';

import {
  View,
} from '@uncinc/react-drupal-core';

const ParagraphLatestThemes = ({ id }) => (
  <div id={id} className="ParagraphLatestThemes">
    <div className="row">
      <div className="ParagraphLatestThemes__inner col-12">
        <View
          className="ParagraphLatestThemes__view"
          id="latest_themes"
          display="latest"
        />
      </div>
    </div>
  </div>
);

export default ParagraphLatestThemes;
